import { render, staticRenderFns } from "./ConsolidaSugestoesBotao.vue?vue&type=template&id=a904f6f0&scoped=true"
import script from "./ConsolidaSugestoesBotao.vue?vue&type=script&lang=js"
export * from "./ConsolidaSugestoesBotao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a904f6f0",
  null
  
)

export default component.exports